import { gql, useQuery } from "@apollo/client";
import { AccessTime, ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Card, Typography, Backdrop, CircularProgress } from "@mui/material";
import { addDays, format, subDays } from "date-fns";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../assets/css/MiniCalendar.css";
import Times from "./Times";
import HourFormat from "../../util/hourFormat";
import Error from "../Error";
import { getCompanyHours } from "../../graphql/querys";
import { differenceInDays } from "date-fns";
import {
  converterDateTime,
  ethDateTime,
  monthStringEth,
  toEthiopianDateTime,
} from "../../util/Ethiopia/Ethiopia";
import { getTimezoneInfo } from "../../util/timezones";
import moment from "moment-timezone";
import { Calc } from "../../util/Ethiopia/CalcBeals";
const MiniCalendar = ({
  startDate,
  endDate,
  selectedDate,
  setSelectedDate,
  setMonthDates,
  link,
  id,
  currentUser,
  spilledDates,
  setSpilledDates,
  start,
  end,
  setCurrentMonth,
  isItLoading,
  decodedToken,
  calendar,
  currentMonth,
  monthDates,
  height,
  isDateGood,
  width,
  datas,
}) => {
  // Create moment objects for both time zones
  const userTime = moment.tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const eventTime = moment.tz(getTimezoneInfo(currentUser.timezone).timezone);
  const timeDifference = (userTime.utcOffset() - eventTime.utcOffset()) / 60;

  // Determine the status message based on the time difference
  let statusMessage = "";
  if (timeDifference === 0) {
    statusMessage = "Same TZ";
  } else {
    statusMessage = `${timeDifference > 0 ? "+" : ""}${timeDifference}h`;
  }
  function getCurrentWeekSundayEthiopian(ethDate) {
    const today = ethDate.date; // Assuming .date gives the day of the month
    const currentDay = ethDate.getDay(); // Assuming .day gives the day of the week

    // If today is Sunday (which might be represented differently in Ethiopian calendar)
    if (currentDay === 0) {
      return new Date(converterDateTime.toEuropean(ethDate));
    }
    return new Date(
      subDays(
        converterDateTime.toEuropean(ethDate),
        Math.abs(today - currentDay)+1
      )
    );
  }
  useEffect(() => {
    currentMonth&&setMonthDates(getMonthDates(currentMonth));
  }, [calendar]);
  const getMonthDates = (date) => {
    if (!date) {
      return false;
    }
    let firstDayOfMonth, lastDayOfMonth, firstDayOfCalendar, lastDayOfCalendar;

    if ((decodedToken?.calendar || calendar) === "Ethiopian") {
      firstDayOfMonth = toEthiopianDateTime(
        new Date(date.getFullYear(), date.getMonth(), 1)
      );
      lastDayOfMonth = toEthiopianDateTime(
        new Date(date.getFullYear(), date.getMonth() + 1, 0)
      );

      firstDayOfCalendar = getCurrentWeekSundayEthiopian(
        new ethDateTime(
          1,
          converterDateTime.toEthiopian(date).month,
          converterDateTime.toEthiopian(date).year
        )
      );
      lastDayOfCalendar = addDays(
        converterDateTime.toEuropean(
          new ethDateTime(
            new ethDateTime(
              1,
              converterDateTime.toEthiopian(date).month,
              converterDateTime.toEthiopian(date).year
            ).monthname.includes("Pagume")
              ? typeof converterDateTime.toEuropean(
                  new ethDateTime(
                    6,
                    converterDateTime.toEthiopian(date).month,
                    converterDateTime.toEthiopian(date).year
                  )
                ) == "string"
                ? 5
                : 6
              : 30,
            converterDateTime.toEthiopian(date).month,
            converterDateTime.toEthiopian(date).year
          )
        ),
        1
      );
    } else {
      firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      firstDayOfCalendar = new Date(
        firstDayOfMonth.getFullYear(),
        firstDayOfMonth.getMonth(),
        firstDayOfMonth.getDate() - firstDayOfMonth.getDay()
      );
      lastDayOfCalendar = new Date(
        lastDayOfMonth.getFullYear(),
        lastDayOfMonth.getMonth(),
        lastDayOfMonth.getDate() + (6 - lastDayOfMonth.getDay())
      );
    }

    let dates = [];
    let currentDate = firstDayOfCalendar;
    while (currentDate <= lastDayOfCalendar) {
      dates.push(new Date(currentDate));
      currentDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() + 1
      );
    }
    return dates;
  };
  const { loading, error, data, refetch } = useQuery(getCompanyHours, {
    variables: {
      userId: parseInt(currentUser.id), // Replace with the user ID you want to filter by
      groupId: datas.groupId,
      hours24: HourFormat(),
    },
  });
  const navigate = useNavigate();
  if (error) {
    console.log(error);
    return <Error />;
  }

  function areDatesEqual(date1, date2) {
    return date1.getDate() === date2.getDate();
  }
  const handleNextMonth = () => {
    var nextMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() + 1,
      1
    );
    if ((decodedToken?.calendar || calendar) == "Ethiopian") {
      if (
        (currentMonth.getMonth() == 8 || currentMonth.getMonth() == 7) &&
        converterDateTime
          .toEthiopian(currentMonth)
          .monthname.includes("Pagume") == false
      ) {
        nextMonth = new Date(
          addDays(
            converterDateTime.toEuropean(
              new ethDateTime(1, 13, getLocalizedMonth(currentMonth, "year"))
            ),
            1
          )
        );
      }
    }
    setMonthDates(getMonthDates(nextMonth));
    setCurrentMonth(nextMonth);
    const newMonthStr = nextMonth.toISOString().substring(0, 7);
    selectedDate
      ? navigate(
          `?month=${newMonthStr}&date=${selectedDate
            .toISOString()
            .substring(0, 10)}`
        )
      : navigate(`?month=${newMonthStr}`);
  };
  const handlePreviousMonth = () => {
    var previousMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() - 1,
      1
    );
    if ((decodedToken?.calendar || calendar) == "Ethiopian") {
      if (
        currentMonth.getMonth() == 9 &&
        converterDateTime
          .toEthiopian(currentMonth)
          .monthname.includes("Pagume") == false
      ) {
        previousMonth = new Date(
          addDays(
            converterDateTime.toEuropean(
              new ethDateTime(
                1,
                13,
                getLocalizedMonth(currentMonth, "year") - 1
              )
            ),
            1
          )
        );
      }
      if (
        converterDateTime.toEthiopian(currentMonth).monthname.includes("Pagume")
      ) {
        previousMonth = new Date(
          addDays(
            converterDateTime.toEuropean(
              new ethDateTime(1, 12, getLocalizedMonth(currentMonth, "year"))
            ),
            1
          )
        );
      }
    }
    setMonthDates(getMonthDates(previousMonth));
    setCurrentMonth(previousMonth);
    const newMonthStr = previousMonth.toISOString().substring(0, 7);
    selectedDate
      ? navigate(
          `?month=${newMonthStr}&date=${selectedDate
            .toISOString()
            .substring(0, 10)}`
        )
      : navigate(`?month=${newMonthStr}`);
  };
  function areDatesEqual(date1, date2) {
    if (!date2) {
      return false;
    }
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }
  const handleSelectDate = (date) => {
    setSelectedDate(date);

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("date", date.toISOString().substring(0, 10));

    if (!searchParams.has("month")) {
      searchParams.set("month", date.toISOString().substring(0, 7));
    }

    navigate(`${window.location.pathname}?${searchParams.toString()}`);
  };
  function good(date) {
    return (
      !isDateGood(date) ||
      data?.getCompanyHours.find((obj) => obj.day == format(date, "EEEE"))
        ?.onJob == 0 ||
      !data?.getCompanyHours.find((obj) => obj.day == format(date, "EEEE"))
    );
  }
  const getLocalizedWeekdays = () => {
    return (decodedToken?.calendar || calendar) === "Ethiopian"
      ? ["እሁድ", "ሰኞ", "ማክሰኞ", "ረቡዕ", "ሐሙስ", "ዓርብ", "ቅዳሜ"]
      : [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
  };

  const getLocalizedMonth = (date, year) => {
    return year
      ? (decodedToken?.calendar || calendar) === "Ethiopian"
        ? toEthiopianDateTime(currentMonth).year
        : currentMonth.getFullYear()
      : (decodedToken?.calendar || calendar) === "Ethiopian"
      ? toEthiopianDateTime(currentMonth).monthname
      : date.toLocaleString("default", { month: "long" })+" ";
  };

  // Conversion utility to be used when displaying Ethiopian dates
  const toEthiopianDate = (date) => {
    return converterDateTime.toEthiopian(new Date(new Date(date)))
    .date;
  };
  const displayDate = (date) => {
    return (decodedToken?.calendar || calendar) === "Ethiopian"
      ? toEthiopianDate(date)
      : date.getDate();
  };

  const weekdays = getLocalizedWeekdays();
  return (
    <div style={{ display: "flex", gap: "20px" }}>
      <div
        className={
          "calendar-container " +
          (isItLoading || loading ? "flex align justify" : "")
        }
        style={{
          maxWidth: width,
          width: "100%",
          flex: 1.4,
          position: "relative",
        }}
      >
        {" "}
        {isItLoading || loading ? (
          <CircularProgress disableShrink />
        ) : !currentMonth ? (
          <div style={{ position: "relative" }}>
            <div
              className="calendar-grid"
              style={{ height: "130px", opacity: "40%" }}
            >
              {weekdays.map((day) => (
                <div key={day} className="weekday">
                  {day.toUpperCase().slice(0, 3)}
                </div>
              ))}
              {getMonthDates(new Date()).map((date, index) => (
                <div
                  style={{
                    height: "50px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div key={index} className="disabled">
                    {date.getDate()}
                  </div>
                </div>
              ))}
            </div>
            <Card
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "240px",
                border: "1px solid black",
                padding: "20px",
                fontWeight: 500,
              }}
            >
              <Typography>No available dates for this event</Typography>
            </Card>
          </div>
        ) : (
          <div>
            <div className="header">
              <h3 className="month">
                {getLocalizedMonth(currentMonth)}{" "}
                {getLocalizedMonth(currentMonth, "year")}
              </h3>
              <div style={{ display: "flex" }}>
                <ChevronLeft
                  disabled
                  className={`prev-btn`}
                  onClick={handlePreviousMonth}
                />
                <ChevronRight
                  className={`next-btn`}
                  onClick={handleNextMonth}
                />
              </div>
            </div>

            <div className="calendar-grid" style={{ minHeight: "130px" }}>
              {weekdays.map((day) => (
                <div key={day} className="weekday">
                  {day.toUpperCase().slice(0, 3)}
                </div>
              ))}
              {monthDates.map((date, index) => {
                var isDate = isDateGood(date);
                const disabled =
                  !isDate ||
                  data?.getCompanyHours.find(
                    (obj) => obj.day == format(date, "EEEE")
                  )?.onJob == 0 ||
                  !data?.getCompanyHours.find(
                    (obj) => obj.day == format(date, "EEEE")
                  ) ||
                  differenceInDays(date, new Date()) < 0;
                return (
                  <div
                    style={{
                      height: "50px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      onClick={
                        loading
                          ? null
                          : disabled
                          ? null
                          : () => handleSelectDate(date)
                      }
                      key={index}
                      style={{
                        display: (
                          (decodedToken?.calendar || calendar) == "Ethiopian"
                            ?  converterDateTime.toEthiopian(
                              new Date(new Date(date))
                            ).month !=
                              converterDateTime.toEthiopian(
                                new Date(currentMonth)
                              ).month
                            : date.getMonth() != currentMonth.getMonth()
                        )
                          ? "none"
                          : "inherit",
                      }}
                      className={
                        loading
                          ? "calendar-date disabled"
                          : `calendar-date ${disabled ? "disabled" : ""} ${
                              differenceInDays(date, new Date()) < 0
                                ? "past"
                                : ""
                            } ${
                              areDatesEqual(date, selectedDate) && !disabled
                                ? "selected"
                                : ""
                            }`
                      }
                    >
                      {displayDate(date)}
                    </div>
                  </div>
                );
              })}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "15px",
              }}
            >
              <AccessTime style={{ marginRight: "5px" }} /> {/* Clock Icon */}
              <Typography className="font2">
                {`TZ difference: ${statusMessage}`}
              </Typography>
            </div>
          </div>
        )}{" "}
      </div>
      {selectedDate !== null && !loading ? (
        <div style={{ flex: 1 }}>
          <Times
            link={link}
            id={id}
            start={start}
            end={end}
            data={datas}
            height={height}
            calendar={calendar}
            decodedToken={decodedToken}
            isDateGood={isDateGood}
            good={good}
            currentUser={currentUser}
            spilledDates={spilledDates}
            setSpilledDates={setSpilledDates}
            selectedDate={selectedDate}
            startDate={startDate}
            endDate={endDate}
            setSelectedDate={setSelectedDate}
            width={width}
          />
        </div>
      ) : (
        ""
      )}{" "}
    </div>
  );
};
export default MiniCalendar;
